import React, { useState, useEffect, useContext, useRef } from 'react';
import StateContext from '../../helpers/ContextState';
import { PostAsync, format } from '../../helpers/Functions';
import Config from '../../helpers/Config';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEdit, faCheck } from '@fortawesome/free-solid-svg-icons';
import Input from '../../components/InputSimple';
import SelectorMultiple from '../../components/SelectorMultiple';
import BotonVolverHome from '../../components/BotonVolverHome';
import filterStorage from '../../helpers/filterStorage';

const SEMESTRES_DATA = [
  { value: '1', label: 'Semestre 1 (Ene–Jun)' },
  { value: '2', label: 'Semestre 2 (Jul–Dic)' },
];

const ASOCIADO_DATA = [
  { value: '1', label: 'Asociado' },
  { value: '0', label: 'No asociado' },
];

const PERIODICIDAD_DATA = [
  { value: '1', label: 'Semanal' },
  { value: '2', label: 'Quincenal' },
  { value: '3', label: 'Mensual' },
  { value: '4', label: 'Por factura' },
];

const CASO_DATA = [
  { value: 'sin_compras',    label: 'Sin compras registradas' },
  { value: 'pendiente_pago', label: 'Pendiente de pago' },
  { value: 'pagado',         label: 'Sin deuda (pagado)' },
];

const PAGADO_REBATE_DATA = [
  { value: '1', label: 'Rebate pagado' },
  { value: '0', label: 'Rebate no pagado' },
];

const STORAGE_KEY = 'rebate_filters_v1';

const App = () => {
  const context = useContext(StateContext);

  const [data, setData]                 = useState([]);
  const [totalizacion, setTotalizacion] = useState({});
  const [proveedores, setProveedores]   = useState([]);
  const [productos, setProductos]       = useState([]);
  const [marcas, setMarcas]             = useState([]);
  const [plantas, setPlantas]           = useState([]);
  const [anios, setAnios]               = useState([]);
  const [loading, setLoading]           = useState(false);

  const [inputs, setInputs]   = useState({ fecha_inicio: '', fecha_fin: '' });
  const [inputs2, setInputs2] = useState({});
  const filterSaveEnabled     = useRef(false);

  const [modalOpen, setModalOpen]           = useState(false);
  const [editRow, setEditRow]               = useState(null);
  const [valorEdit, setValorEdit]           = useState('');
  const [conceptoEdit, setConceptoEdit]     = useState('');
  const [usaKilosEdit, setUsaKilosEdit]     = useState(1);
  const [savingEdit, setSavingEdit]         = useState(false);
  const [msgEdit, setMsgEdit]               = useState('');

  const [modalMasivo, setModalMasivo]       = useState(false);
  const [selectedRows, setSelectedRows]     = useState({});
  const [valorMasivo, setValorMasivo]       = useState('');
  const [conceptoMasivo, setConceptoMasivo] = useState('');
  const [savingMasivo, setSavingMasivo]     = useState(false);
  const [usaKilosMasivo, setUsaKilosMasivo] = useState(1);
  const [alertEdit, setAlertEdit]           = useState(null);
  const [alertMasivo, setAlertMasivo]       = useState(null);

  useEffect(() => {
    PostAsync('Informes', 'GetAniosCompras', {}, context).then((res) => {
      if (res && !res.error && res.data) setAnios(res.data);
    });
    const saved = filterStorage.restore(STORAGE_KEY);
    if (saved) {
      if (saved.inputs && Object.keys(saved.inputs).some(k => saved.inputs[k])) {
        setInputs(prev => ({ ...prev, ...saved.inputs }));
      }
      if (saved.inputs2 && Object.keys(saved.inputs2).some(k => Array.isArray(saved.inputs2[k]) && saved.inputs2[k].length > 0)) {
        setInputs2(saved.inputs2);
      }
    }
    setTimeout(() => { filterSaveEnabled.current = true; }, 0);
  }, []);

  useEffect(() => {
    if (filterSaveEnabled.current) filterStorage.save(STORAGE_KEY, inputs, inputs2);
    getInit();
  }, [inputs, inputs2]);

  const getFiltroMultiple = () => {
    const { semestre, anio, periodicidad_pago, caso_filtro, rebate_pagado, ...resto } = inputs2;
    return resto;
  };

  const getSemestreParam    = () => (inputs2.semestre         || []).map(o => o.value).join(',');
  const getAnioParam        = () => (inputs2.anio             || []).map(o => o.value).join(',');
  const getPeriodicidadParam= () => (inputs2.periodicidad_pago|| []).map(o => o.value).join(',');
  const getCasoFiltroParam  = () => (inputs2.caso_filtro      || []).map(o => o.value).join(',');
  const getRebatePagadoParam= () => (inputs2.rebate_pagado    || []).map(o => o.value).join(',');

  const getInit = () => {
    setLoading(true);
    setData([]);
    PostAsync('Informes', 'ListadoRebate', {
      ...inputs,
      semestre:          getSemestreParam(),
      anio:              getAnioParam(),
      periodicidad_pago: getPeriodicidadParam(),
      caso_filtro:       getCasoFiltroParam(),
      rebate_pagado:     getRebatePagadoParam(),
      filtroMultiple:    JSON.stringify(getFiltroMultiple()),
    }, context).then((res) => {
      setLoading(false);
      if (!res || res.error) return;
      if (res.data) {
        setData(res.data.rows || []);
        setProveedores(res.data.proveedores || []);
        setProductos(res.data.productos    || []);
        setMarcas(res.data.marcas          || []);
        setPlantas(res.data.plantas        || []);
      }
      if (res.totalizacion) setTotalizacion(res.totalizacion);
    });
  };

  const onChangeCustom = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const getRowStyle = (row) => {
    if (row.pagado_rebate == 1) return { borderLeft: '4px solid #27ae60', background: '#eafaf1' };
    switch (row.caso) {
      case 'sin_compras':    return { borderLeft: '4px solid #e1b12c' };
      case 'pendiente_pago': return { borderLeft: '4px solid #0652DD' };
      default:               return {};
    }
  };

  const showAlert = (icon, iconClass, title, body) => {
    context.setModalShow({
      show: true, size: 'sm',
      message: (
        <div className="text-center">
          <div className={`mb-2 ${iconClass}`} style={{ fontSize: '2rem' }}>{icon}</div>
          <div className="fw-bold mb-2">{title}</div>
          <div className="text-muted small mb-3">{body}</div>
          <button className="btn btn-primary" onClick={() => context.setModalShow({ show: false, message: '', size: 'sm' })}>Entendido</button>
        </div>
      ),
    });
  };

  const onEditOpen = (row) => {
    if (row.caso === 'sin_compras') {
      showAlert(
        <>&#9888;</>,
        'text-warning',
        'Sin compras registradas',
        <><b>{row.proveedor_nombre}</b> no tiene compras faenadas para <b>{row.producto_nombre}</b> en este período. No es posible editar el rebate hasta que existan compras registradas.</>
      );
      return;
    }
    setEditRow(row);
    setValorEdit(row.valor_unitario || '0');
    setConceptoEdit(row.concepto || '');
    setUsaKilosEdit(row.usa_kilos != null ? parseInt(row.usa_kilos) : 1);
    setMsgEdit('');
    setAlertEdit(null);
    setModalOpen(true);
  };

  const onEditSave = () => {
    if (!editRow) return;
    if (usaKilosEdit === 1 && parseFloat(editRow.kilos_total || 0) === 0) {
      setAlertEdit({
        title: 'Rebate por Kg no aplicable',
        body: <><b>{editRow.producto_nombre}</b> es un producto vendido por unidades (Kilos = 0). Si se multiplica por Kg el rebate resultará $0. Selecciona <b>Unidades</b> como base de cálculo.</>,
      });
      return;
    }
    setSavingEdit(true);
    PostAsync('Informes', 'GuardarValorUnitarioRebate', {
      proveedor_id:           editRow.proveedor_id,
      op_inventario_items_id: editRow.op_inventario_items_id,
      semestre:               editRow.semestre,
      anio:                   editRow.anio,
      valor_unitario:         valorEdit,
      concepto:               conceptoEdit,
      usa_kilos:              usaKilosEdit,
    }, context).then((res) => {
      setSavingEdit(false);
      if (!res || res.error) { setMsgEdit('Error: ' + (res?.message || '')); return; }
      setModalOpen(false);
      getInit();
    });
  };

  const onTogglePagado = (row) => {
    if (row.pagado_rebate != 1 && (row.caso === 'sin_compras' || row.caso === 'pendiente_pago')) {
      const msg = row.caso === 'sin_compras'
        ? <>
            <div className="mb-2 text-warning" style={{ fontSize: '2rem' }}>&#9888;</div>
            <div className="fw-bold mb-2">Sin compras registradas</div>
            <div className="text-muted small mb-3">
              <b>{row.proveedor_nombre}</b> no tiene compras registradas para <b>{row.producto_nombre}</b> en este período.
              El rebate no puede marcarse como pagado hasta que existan compras faenadas y completamente pagadas asociadas a este proveedor y producto.
            </div>
          </>
        : <>
            <div className="mb-2 text-primary" style={{ fontSize: '2rem' }}>&#9432;</div>
            <div className="fw-bold mb-2">Compras pendientes de pago</div>
            <div className="text-muted small mb-3">
              <b>{row.proveedor_nombre}</b> tiene compras de <b>{row.producto_nombre}</b> que aún no han sido completamente facturadas o pagadas.
              Para marcar el rebate como pagado, todas las compras del período deben estar en estado <b>pagado</b>.
            </div>
          </>;
      context.setModalShow({
        show: true,
        size: 'sm',
        message: (
          <div className="text-center">
            {msg}
            <div
              className="btn btn-primary"
              onClick={() => context.setModalShow({ show: false, message: '', size: 'sm' })}
            >
              Entendido
            </div>
          </div>
        ),
      });
      return;
    }
    PostAsync('Informes', 'GuardarPagadoRebate', {
      proveedor_id:           row.proveedor_id,
      op_inventario_items_id: row.op_inventario_items_id,
      semestre:               row.semestre,
      anio:                   row.anio,
      pagado_rebate:          row.pagado_rebate == 1 ? 0 : 1,
    }, context).then((res) => {
      if (!res || res.error) return;
      getInit();
    });
  };

  const toggleSelectRow = (idx) => {
    setSelectedRows(prev => ({ ...prev, [idx]: !prev[idx] }));
  };

  const toggleSelectAll = (e) => {
    const all = {};
    if (e.target.checked) data.forEach((_, i) => { all[i] = true; });
    setSelectedRows(all);
  };

  const callPagadoMasivo = (registros, pagado_rebate) => {
    PostAsync('Informes', 'GuardarMasivoPagadoRebate', {
      pagado_rebate,
      registros: JSON.stringify(registros.map(r => ({
        proveedor_id:           r.proveedor_id,
        op_inventario_items_id: r.op_inventario_items_id,
        semestre:               r.semestre,
        anio:                   r.anio,
      }))),
    }, context).then((res) => {
      if (!res || res.error) return;
      setSelectedRows({});
      getInit();
    });
  };

  const onMarcarPagadoMasivo = () => {
    const seleccionados = data.filter((_, idx) => selectedRows[idx]);
    const invalidos     = seleccionados.filter(r => r.caso !== 'pagado');

    if (invalidos.length > 0) {
      context.setModalShow({
        show: true, size: 'sm',
        message: (
          <div className="text-center">
            <div className="mb-2 text-warning" style={{ fontSize: '2rem' }}>&#9888;</div>
            <div className="fw-bold mb-2">No se puede marcar como pagado</div>
            <div className="text-muted small mb-3">
              {invalidos.length} registro(s) seleccionado(s) no están completamente listos
              (tienen compras pendientes o sin compras faenadas).
              Todos los registros seleccionados deben estar <b>sin deuda</b> para poder marcarlos.
            </div>
            <div className="btn btn-primary btn-sm" onClick={() => context.setModalShow({ show: false, message: '', size: 'sm' })}>Entendido</div>
          </div>
        ),
      });
      return;
    }

    callPagadoMasivo(seleccionados, 1);
  };

  const onQuitarPagadoMasivo = () => {
    const seleccionados = data.filter((_, idx) => selectedRows[idx]);
    const marcados      = seleccionados.filter(r => r.pagado_rebate == 1);

    if (marcados.length === 0) {
      context.setModalShow({
        show: true, size: 'sm',
        message: (
          <div className="text-center">
            <div className="mb-2 text-secondary" style={{ fontSize: '2rem' }}>&#9432;</div>
            <div className="fw-bold mb-2">Nada que desmarcar</div>
            <div className="text-muted small mb-3">
              Ninguno de los {seleccionados.length} registro(s) seleccionado(s) tiene el rebate marcado como pagado.
            </div>
            <div className="btn btn-primary btn-sm" onClick={() => context.setModalShow({ show: false, message: '', size: 'sm' })}>Entendido</div>
          </div>
        ),
      });
      return;
    }

    callPagadoMasivo(marcados, 0);
  };

  const doMasivoSave = () => {
    const seleccionados = data.filter((_, idx) => selectedRows[idx]);
    setSavingMasivo(true);
    PostAsync('Informes', 'GuardarMasivoRebate', {
      valor_unitario: valorMasivo,
      concepto:       conceptoMasivo,
      usa_kilos:      usaKilosMasivo,
      registros:      JSON.stringify(seleccionados.map(r => ({
        proveedor_id:           r.proveedor_id,
        op_inventario_items_id: r.op_inventario_items_id,
        semestre:               r.semestre,
        anio:                   r.anio,
      }))),
    }, context).then((res) => {
      setSavingMasivo(false);
      if (!res || res.error) return;
      setModalMasivo(false);
      setSelectedRows({});
      getInit();
    });
  };

  const onMasivoSave = () => {
    const seleccionados = data.filter((_, idx) => selectedRows[idx]);
    if (seleccionados.length === 0) return;

    const noFaenados = seleccionados.filter(r => r.caso === 'sin_compras');
    if (noFaenados.length > 0) {
      setAlertMasivo({
        title: 'Sin compras registradas',
        body: <>{noFaenados.length} registro(s) seleccionado(s) no tienen compras faenadas. El rebate no puede aplicarse hasta que existan compras registradas.</>,
      });
      return;
    }

    if (usaKilosMasivo === 1) {
      const unidadRows = seleccionados.filter(r => parseFloat(r.kilos_total || 0) === 0);
      if (unidadRows.length > 0) {
        setAlertMasivo({
          title: 'Rebate por Kg no aplicable',
          body: <>{unidadRows.length} registro(s) son de productos vendidos por unidades (Kilos = 0). Multiplicar por Kg daría un rebate de $0. Selecciona <b>Unidades</b> como base de cálculo.</>,
        });
        return;
      }
    }

    const conRebate = seleccionados.filter(r => parseFloat(r.valor_unitario || 0) > 0);
    if (conRebate.length > 0) {
      setAlertMasivo({
        title: 'Rebate ya asignado',
        body: <>{conRebate.length} registro(s) de los seleccionados ya tienen rebate asignado. ¿Desea sobrescribirlos?</>,
        isConfirm: true,
      });
      return;
    }

    doMasivoSave();
  };

  const buildPdfQuery = () => {
    let uri = '';
    if (inputs.fecha_inicio) uri += '&fecha_inicio=' + inputs.fecha_inicio;
    if (inputs.fecha_fin)    uri += '&fecha_fin='    + inputs.fecha_fin;
    const sem       = getSemestreParam();
    const anio      = getAnioParam();
    const perio     = getPeriodicidadParam();
    const caso      = getCasoFiltroParam();
    const rebPagado = getRebatePagadoParam();
    if (sem)       uri += '&semestre='          + sem;
    if (anio)      uri += '&anio='              + anio;
    if (perio)     uri += '&periodicidad_pago=' + perio;
    if (caso)      uri += '&caso_filtro='       + caso;
    if (rebPagado) uri += '&rebate_pagado='     + rebPagado;
    const filtro = getFiltroMultiple();
    Object.entries(filtro).forEach(([, arr]) => {
      if (arr && arr.length > 0) arr.forEach((item) => { uri += '&' + item.name + '[]=' + item.value; });
    });
    const filtroJson = JSON.stringify(filtro);
    if (filtroJson !== '{}') uri += '&filtroMultiple=' + encodeURIComponent(filtroJson);
    const _sel = data.filter((_, i) => selectedRows[i]).map(r => ({ proveedor_id: r.proveedor_id, op_inventario_items_id: r.op_inventario_items_id, semestre: r.semestre, anio: r.anio }));
    if (_sel.length > 0) uri += '&seleccion=' + encodeURIComponent(JSON.stringify(_sel));
    return uri;
  };

  const getPdfUrl = () => {
    const q = buildPdfQuery().replace(/^&/, '');
    const base = Config.ConfigApirest + 'PDF/Informes/ListadoRebate/' + context.user.token;
    return q ? base + '?' + q : base;
  };

  const excelBaseUrl      = Config.ConfigApirest + 'Excel/Informes/ListadoRebateExcel/token:'  + context.user.token;
  const wordOfficeBaseUrl = Config.ConfigApirest + 'Excel/Informes/WordOfficeRebate/token:' + context.user.token;

  const buildExportFilters = (baseUri) => {
    let uri = baseUri + '?';
    if (inputs.fecha_inicio) uri += 'fecha_inicio=' + inputs.fecha_inicio + '&';
    if (inputs.fecha_fin)    uri += 'fecha_fin='    + inputs.fecha_fin    + '&';
    const sem       = getSemestreParam();
    const anio      = getAnioParam();
    const perio     = getPeriodicidadParam();
    const caso      = getCasoFiltroParam();
    const rebPagado = getRebatePagadoParam();
    if (sem)       uri += 'semestre='          + sem       + '&';
    if (anio)      uri += 'anio='              + anio      + '&';
    if (perio)     uri += 'periodicidad_pago=' + perio     + '&';
    if (caso)      uri += 'caso_filtro='       + caso      + '&';
    if (rebPagado) uri += 'rebate_pagado='     + rebPagado + '&';
    const filtro = getFiltroMultiple();
    Object.entries(filtro).forEach(([, arr]) => {
      if (arr && arr.length > 0) arr.forEach((item) => { uri += item.name + '[]=' + item.value + '&'; });
    });
    const filtroJson = JSON.stringify(filtro);
    if (filtroJson !== '{}') uri += 'filtroMultiple=' + encodeURIComponent(filtroJson) + '&';
    const _sel = data.filter((_, i) => selectedRows[i]).map(r => ({ proveedor_id: r.proveedor_id, op_inventario_items_id: r.op_inventario_items_id, semestre: r.semestre, anio: r.anio }));
    if (_sel.length > 0) uri += 'seleccion=' + encodeURIComponent(JSON.stringify(_sel)) + '&';
    return uri;
  };

  const openExcel = (e) => {
    e.preventDefault();
    window.open(buildExportFilters(e.target.href));
  };

  const openWordOffice = (e) => {
    e.preventDefault();
    window.open(buildExportFilters(e.target.href));
  };

  const emptyTds    = (n) => Array.from({ length: n }).map((_, i) => <td key={i}></td>);
  const cxpDisplay  = (val) => (val && val !== '—') ? val : '';
  const someSelected = Object.values(selectedRows).some(Boolean);
  const selectedCount = Object.values(selectedRows).filter(Boolean).length;
  const rebateBase  = (row) => row.usa_kilos == 1 ? row.kilos_total_format : (row.cantidad_total_format || row.cantidad_total);

  return (
    <div className="container-fluid" style={{ marginTop: '60px' }}>

      <div className="row justify-content-end">
        <BotonVolverHome />
        <div className="col-12 col-sm-6 mb-3 text-end">
          {someSelected && (
            <>
              <button className="btn btn-success me-2" onClick={() => { setAlertMasivo(null); setModalMasivo(true); }}>
                Actualizar seleccionados ({selectedCount})
              </button>
              <button className="btn btn-outline-success me-2" onClick={onMarcarPagadoMasivo}>
                <FontAwesomeIcon icon={faCheck} className="me-1" />Marcar pagado ({selectedCount})
              </button>
              <button className="btn btn-outline-secondary me-2" onClick={onQuitarPagadoMasivo}>
                Quitar marca pagado ({selectedCount})
              </button>
            </>
          )}
          <a className="btn btn-primary me-2" href={excelBaseUrl} target="_blank" onClick={openExcel}>Exportar</a>
          <a className="btn btn-secondary me-2" href={getPdfUrl()} target="_blank" rel="noreferrer">PDF</a>
          <a className="btn btn-success" href={wordOfficeBaseUrl} target="_blank" onClick={openWordOffice}>WordOffice</a>
        </div>
      </div>

      <div className="row bg-gray">
        <div className="col-12"><b>Filtros de búsqueda en rebate</b></div>

        <div className="col-12 col-sm-2 mb-2 pt-1">
          <Input value={inputs.fecha_inicio} title="Fecha compra desde" placeholder="Fecha desde"
            type="date" name="fecha_inicio" className="form-control form-control-sm" onChange={onChangeCustom} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <Input value={inputs.fecha_fin} title="Fecha compra hasta" placeholder="Fecha hasta"
            type="date" name="fecha_fin" className="form-control form-control-sm" onChange={onChangeCustom} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <SelectorMultiple name="semestre" title="Semestre" selectDefault="Semestre"
            data={SEMESTRES_DATA} inputs={inputs2} setInputs={setInputs2} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <SelectorMultiple name="anio" title="Año" selectDefault="Año"
            data={anios} inputs={inputs2} setInputs={setInputs2} />
        </div>
        <div className="col-12 col-sm-3 mb-2 pt-1">
          <SelectorMultiple name="proveedor_id" title="Proveedor" selectDefault="Proveedor"
            data={proveedores} inputs={inputs2} setInputs={setInputs2} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <SelectorMultiple name="op_inventario_items_id" title="Producto" selectDefault="Producto"
            data={productos} inputs={inputs2} setInputs={setInputs2} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <SelectorMultiple name="marca_id" title="Marca" selectDefault="Marca"
            data={marcas} inputs={inputs2} setInputs={setInputs2} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <SelectorMultiple name="planta_id" title="Planta" selectDefault="Planta"
            data={plantas} inputs={inputs2} setInputs={setInputs2} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <SelectorMultiple name="es_asociado" title="Tipo proveedor" selectDefault="Asociado / No asociado"
            data={ASOCIADO_DATA} inputs={inputs2} setInputs={setInputs2} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <SelectorMultiple name="periodicidad_pago" title="Periodicidad" selectDefault="Periodicidad de pago"
            data={PERIODICIDAD_DATA} inputs={inputs2} setInputs={setInputs2} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <SelectorMultiple name="caso_filtro" title="Estado cuenta" selectDefault="Estado de cuenta"
            data={CASO_DATA} inputs={inputs2} setInputs={setInputs2} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <SelectorMultiple name="rebate_pagado" title="Rebate pagado" selectDefault="Rebate pagado / no pagado"
            data={PAGADO_REBATE_DATA} inputs={inputs2} setInputs={setInputs2} />
        </div>
      </div>

      <div className="row mt-2 mb-1">
        <div className="col small text-muted">
          <span style={{ borderLeft: '4px solid #27ae60', paddingLeft: '6px', marginRight: '12px' }}>
            Rebate marcado como pagado
          </span>
          <span style={{ borderLeft: '4px solid #0652DD', paddingLeft: '6px', marginRight: '12px' }}>
            Faenaron — pendiente de facturar/pagar
          </span>
          <span style={{ borderLeft: '4px solid #e1b12c', paddingLeft: '6px', marginRight: '12px' }}>
            No faenaron — sin compras registradas
          </span>
          <span style={{ paddingLeft: '6px' }}>
            Sin borde — faenaron y todo pagado
          </span>
        </div>
      </div>

      <div className="row">
        <div className="col">
          {loading ? (
            <div className="text-center py-5"><div className="spinner-border text-secondary" role="status" /></div>
          ) : data.length === 0 ? (
            <div className="alert alert-info mt-3">No hay registros para mostrar.</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table className="table table-striped table-sm">
                <thead>
                  <tr>
                    <th style={{ width: '30px' }}>
                      <input type="checkbox" onChange={toggleSelectAll} />
                    </th>
                    <th className="text-left small">Proveedor</th>
                    <th className="text-center small">NIT</th>
                    <th className="text-center small">Tipo</th>
                    <th className="text-center small">Resp. IVA</th>
                    <th className="text-center small">Semestre</th>
                    <th className="text-left small">Producto</th>
                    <th className="text-left small">Marcas</th>
                    <th className="text-center small">Unidades</th>
                    <th className="text-center small">Kilos</th>
                    <th className="text-center small">Subtotal</th>
                    <th className="text-center small">Vr. Unit.</th>
                    <th className="text-center small">Vr. Rebate</th>
                    <th className="text-center small">Promedio</th>
                    <th className="text-center small">IVA</th>
                    <th className="text-center small">ReteRebate</th>
                    <th className="text-center small">P. Total</th>
                    <th className="text-center small">Concepto Rebate</th>
                    <th className="text-center small">Periodicidad</th>
                    <th className="text-center small">Estado CXP</th>
                    <th className="text-center small">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, idx) => (
                    <tr key={idx} style={getRowStyle(row)}>
                      <td className="text-center">
                        <input type="checkbox" checked={!!selectedRows[idx]} onChange={() => toggleSelectRow(idx)} />
                      </td>
                      <td className="small">{row.proveedor_nombre}</td>
                      <td className="text-center small">{row.proveedor_cedula}</td>
                      <td className="text-center small">{row.es_asociado_string}</td>
                      <td className="text-center small">{row.responsable_iva}</td>
                      <td className="text-center small">{row.semestre_label}</td>
                      <td className="small">{row.producto_nombre}</td>
                      <td className="small">{row.marca_nombre || ''}</td>
                      <td className="text-end small">{row.cantidad_total_format || row.cantidad_total}</td>
                      <td className="text-end small">{row.kilos_total_format}</td>
                      <td className="text-end small">{row.subtotal_sin_imp_string}</td>
                      <td className="text-end small">
                        {row.valor_unitario_format}
                        <span className="text-muted" style={{ fontSize: '10px', display: 'block' }}>
                          /{row.usa_kilos == 1 ? 'kg' : 'und'}
                        </span>
                      </td>
                      <td className="text-end small"><b>{row.valor_rebate_format}</b></td>
                      <td className="text-end small">{row.promedio_piel_kilos_format}</td>
                      <td className="text-end small">{row.iva_total_string}</td>
                      <td className="text-end small">{row.calculo_reterebate}</td>
                      <td className="text-end small"><b>{row.precio_total_rebate_string}</b></td>
                      <td className="small" title={row.concepto || ''}>{row.concepto && row.concepto.length > 15 ? row.concepto.substr(0, 15) + '...' : (row.concepto || '')}</td>
                      <td className="text-center small">{row.periodicidad_label || ''}</td>
                      <td className="text-center small">{cxpDisplay(row.cxp_string)}</td>
                      <td className="text-center small" style={{ whiteSpace: 'nowrap' }}>
                        <button className="btn btn-warning btn-sm me-1" title="Editar valor unitario de rebate"
                          onClick={() => onEditOpen(row)}>
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <button
                          className={`btn btn-sm me-1 ${row.pagado_rebate == 1 ? 'btn-success' : 'btn-outline-secondary'}`}
                          title={row.pagado_rebate == 1 ? 'Desmarcar rebate pagado' : 'Marcar rebate como pagado'}
                          onClick={() => onTogglePagado(row)}
                        >
                          <FontAwesomeIcon icon={faCheck} />
                        </button>
                        <NavLink className="btn btn-primary btn-sm" title="Ver detalle"
                          to={`/Informes/InformesRebate/Detalle/${row.proveedor_id}/${row.op_inventario_items_id}/${row.semestre}/${row.anio}`}>
                          <FontAwesomeIcon icon={faEye} />
                        </NavLink>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    {emptyTds(8)}
                    <td className="bg-secondary text-white p-1 small text-end"><b>{totalizacion.cantidad_format}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{totalizacion.kilos_format}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{totalizacion.subtotal_sin_imp_string}</b></td>
                    <td></td>
                    <td className="bg-primary text-white p-1 small text-end"><b>{totalizacion.valor_rebate_format}</b></td>
                    <td></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{totalizacion.iva_total_string}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{totalizacion.calculo_reterebate}</b></td>
                    <td className="bg-primary text-white p-1 small text-end"><b>{totalizacion.precio_total_rebate_string}</b></td>
                    {emptyTds(4)}
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>
      </div>

      {modalOpen && editRow && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="bg-white p-4" style={{ borderRadius: '4px', minWidth: '360px', maxWidth: '460px', width: '95%' }}>
            <h6 className="mb-3 border-bottom pb-2"><b>Editar Valor Unitario de Rebate</b></h6>
            <div className="small text-muted mb-3">
              <div><b>Proveedor:</b> {editRow.proveedor_nombre}</div>
              <div><b>Producto:</b>  {editRow.producto_nombre}</div>
              <div><b>Semestre:</b>  {editRow.semestre_label}
                &nbsp;&nbsp;<b>Kilos:</b> {editRow.kilos_total_format}
                &nbsp;&nbsp;<b>Unidades:</b> {editRow.cantidad_total}
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label small mb-1"><b>Multiplicar vr. unitario por</b></label>
              <div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" id="rbKilos" name="usa_kilos_modal"
                    checked={usaKilosEdit === 1} onChange={() => { setUsaKilosEdit(1); setAlertEdit(null); }} />
                  <label className="form-check-label small" htmlFor="rbKilos">Kilos</label>
                </div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" id="rbUnidades" name="usa_kilos_modal"
                    checked={usaKilosEdit === 0} onChange={() => { setUsaKilosEdit(0); setAlertEdit(null); }} />
                  <label className="form-check-label small" htmlFor="rbUnidades">Unidades</label>
                </div>
              </div>
            </div>
            <div className="mb-2">
              <label className="form-label small mb-1"><b>Valor Unitario ($ por {usaKilosEdit ? 'kg' : 'unidad'})</b></label>
              <input type="number" className="form-control form-control-sm" step="0.01" min="0"
                value={valorEdit} onChange={(e) => setValorEdit(e.target.value)} />
              <div className="text-muted small mt-1">
                Rebate estimado:&nbsp;
                <b>${format(parseFloat(valorEdit || 0) * parseFloat(usaKilosEdit ? (editRow.kilos_total || 0) : (editRow.cantidad_total || 0)))}</b>
              </div>
            </div>
            <div className="mb-2">
              <label className="form-label small mb-1"><b>Concepto pago rebate</b></label>
              <input type="text" className="form-control form-control-sm" placeholder="Concepto..."
                value={conceptoEdit} onChange={(e) => setConceptoEdit(e.target.value)} />
            </div>
            {msgEdit && <div className="alert alert-danger py-1 small mb-2">{msgEdit}</div>}
            {alertEdit && (
              <div className="alert alert-warning py-2 small mb-2">
                <div className="fw-bold mb-1">&#9888; {alertEdit.title}</div>
                <div>{alertEdit.body}</div>
              </div>
            )}
            <div className="d-flex justify-content-end gap-2">
              <button className="btn btn-secondary btn-sm" onClick={() => { setModalOpen(false); setAlertEdit(null); }}>Cancelar</button>
              <button className="btn btn-primary btn-sm" onClick={onEditSave} disabled={savingEdit}>
                {savingEdit ? 'Guardando...' : 'Guardar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {modalMasivo && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="bg-white p-4" style={{ borderRadius: '4px', minWidth: '340px', maxWidth: '420px', width: '95%' }}>
            <h6 className="mb-3 border-bottom pb-2"><b>Actualización Masiva de Rebate</b></h6>
            <div className="small text-muted mb-3">
              Se actualizarán <b>{selectedCount}</b> registro(s) seleccionado(s).
            </div>
            <div className="mb-3">
              <label className="form-label small mb-1"><b>Multiplicar vr. unitario por</b></label>
              <div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" id="rbKilosMasivo" name="usa_kilos_masivo"
                    checked={usaKilosMasivo === 1} onChange={() => { setUsaKilosMasivo(1); setAlertMasivo(null); }} />
                  <label className="form-check-label small" htmlFor="rbKilosMasivo">Kilos</label>
                </div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" id="rbUnidadesMasivo" name="usa_kilos_masivo"
                    checked={usaKilosMasivo === 0} onChange={() => { setUsaKilosMasivo(0); setAlertMasivo(null); }} />
                  <label className="form-check-label small" htmlFor="rbUnidadesMasivo">Unidades</label>
                </div>
              </div>
            </div>
            <div className="mb-2">
              <label className="form-label small mb-1"><b>Valor Unitario ($ por {usaKilosMasivo ? 'kg' : 'unidad'})</b></label>
              <input type="number" className="form-control form-control-sm" step="0.01" min="0"
                value={valorMasivo} onChange={(e) => setValorMasivo(e.target.value)} />
            </div>
            <div className="mb-3">
              <label className="form-label small mb-1"><b>Concepto pago rebate</b></label>
              <input type="text" className="form-control form-control-sm" placeholder="Concepto..."
                value={conceptoMasivo} onChange={(e) => setConceptoMasivo(e.target.value)} />
            </div>
            {alertMasivo && (
              <div className="alert alert-warning py-2 small mb-3">
                <div className="fw-bold mb-1">&#9888; {alertMasivo.title}</div>
                <div className="mb-2">{alertMasivo.body}</div>
                {alertMasivo.isConfirm && (
                  <div className="d-flex gap-2 mt-2">
                    <button className="btn btn-secondary btn-sm" onClick={() => setAlertMasivo(null)}>Cancelar</button>
                    <button className="btn btn-primary btn-sm" onClick={() => { setAlertMasivo(null); doMasivoSave(); }}>Continuar</button>
                  </div>
                )}
              </div>
            )}
            <div className="d-flex justify-content-end gap-2">
              <button className="btn btn-secondary btn-sm" onClick={() => { setModalMasivo(false); setAlertMasivo(null); }}>Cancelar</button>
              <button className="btn btn-primary btn-sm" onClick={onMasivoSave} disabled={savingMasivo || selectedCount === 0}>
                {savingMasivo ? 'Guardando...' : `Aplicar a ${selectedCount} registros`}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default App;
